import { StepperSelectionEvent }                                                         from '@angular/cdk/stepper';
import { APP_BASE_HREF, NgIf }                                                           from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, inject, OnInit } from '@angular/core';
import { FormBuilder }                                                                   from '@angular/forms';
import { MatButtonModule }                                                       from '@angular/material/button';
import { MatDialog }                                                             from '@angular/material/dialog';
import { MatIconModule }                                                         from '@angular/material/icon';
import { MatStepper, MatStepperModule }                                          from '@angular/material/stepper';
import { ActivatedRoute }                                                        from '@angular/router';
import { UntilDestroy, untilDestroyed }                                          from '@ngneat/until-destroy';
import { LetDirective, PushPipe }                                                from '@ngrx/component';
import { Store }                                                                 from '@ngrx/store';
import { Caisse }                                                                from '@shared/classes/caisse';
import { User }                                                                  from '@shared/classes/user';
import { EnumOuiNon }                                                            from '@shared/enums/enumOuiNon';
import { FeatureSpinnerEnum }                                                    from '@shared/enums/featureSpinner.enum';
import { capitalize }                                                            from '@shared/helper/LDHelper';
import { of }                                                                    from 'rxjs';
import { map, withLatestFrom }                                                   from 'rxjs/operators';
import { CAISSE, GENERIC_TAGS_OBJ_INTERFACE }                                    from 'src/app/components/main/self-care/self-care.constants';
import { VerticalStepperScrollDirective }                                        from 'src/app/directives/vertical-stepper-scroll.directive';
import { ButtonFixedComponent }                                                  from 'src/app/shared/components/button/button-fixed/button-fixed.component';
import { ButtonNormalComponent }                                                 from 'src/app/shared/components/button/button-normal/button-normal.component';
import { initProfessions }                                                       from 'src/app/shared/ngrx/store/actions/config.actions';
import { updateState }                                                           from 'src/app/shared/ngrx/store/actions/user.actions';
import { selectCaisses }                                                         from 'src/app/shared/ngrx/store/selectors/config.selector';
import { selectLoadingByKey }                                                    from 'src/app/shared/ngrx/store/selectors/spinner.selector';
import { selectUser }                                                            from 'src/app/shared/ngrx/store/selectors/user.selector';
import { IAppState }                                                             from 'src/app/shared/ngrx/store/state/app.state';
import { ShowInfoPipePipe }                                                      from 'src/app/shared/pipe/showInfoDateNaissance.pipe';
import { QueryParams }                                                           from 'src/app/shared/queryParams/queryParams';
import { TechnicalService }                                                      from 'src/app/shared/services/technical.service';
import { Etape3_trackingEnum }                                                   from 'src/app/shared/services/trackingService/button_tracking.enum';
import { GenericTagsObjInterface }                                               from 'src/app/shared/services/trackingService/genericTagsObjInterface';
import { TrackingService }                                                       from 'src/app/shared/services/trackingService/tracking.service';
import { ButtonCallApi }                                                         from 'src/app/shared/utils/buttonCallApi';
import { Helper }                                                                from 'src/app/shared/utils/helper';
import { environment }                                                           from 'src/environments/environment';
import { ButtonsEnum }                                                           from '../../shared/buttons/buttons.enum';
import { AbstractMainComponent }                                                 from '../abstractMain.component';
import { StepFourComponent }                                                     from '../steps/step-four/step-four.component';
import { StepOneComponent }                                                      from '../steps/step-one/step-one.component';
import { StepThreeComponent }                                                    from '../steps/step-three/step-three.component';
import { FIXED_BUTTON }                                                          from '../steps/step-three/step-three.constants';
import { StepTwoComponent }                                                      from '../steps/step-two/step-two.component';
import { SelfCareService }                                                       from './self-care.service';

@UntilDestroy ()
@Component ({
              selector:        'app-self-care',
              templateUrl:     './self-care.component.html',
              styleUrls:       ['./self-care.component.scss'],
              changeDetection: ChangeDetectionStrategy.OnPush,
              standalone:      true,
              imports: [
                MatStepperModule,
                MatIconModule,
                PushPipe,
                NgIf,
                StepOneComponent,
                MatButtonModule,
                StepTwoComponent,
                StepThreeComponent,
                ButtonFixedComponent,
                StepFourComponent,
                ButtonNormalComponent,
                VerticalStepperScrollDirective,
                LetDirective,
                ShowInfoPipePipe,
              ],
              providers:       [],
            })
export class SelfCareComponent extends AbstractMainComponent implements OnInit {

  public selectSendEmail$ = this._store.select (selectLoadingByKey (FeatureSpinnerEnum.SEND_EMAIL));

  public buttonCallApi: ButtonCallApi;
  public email    = {
    ...FIXED_BUTTON[ButtonsEnum.RECEVOIR_PAR_EMAIL],
    key: ButtonsEnum.RECEVOIR_PAR_EMAIL,
  };
  public isLinear = true;
  public currentStep: number;
  public isDev: boolean;

  private readonly route: ActivatedRoute = inject (ActivatedRoute);

  // fixme remplacer par des injects plus propre
  constructor (
    override _store: Store<IAppState>,
    override _fb: FormBuilder,
    protected _dialog: MatDialog,
    protected _cdr: ChangeDetectorRef,
    override _technicalService: TechnicalService,
    private _trackingService: TrackingService,
    override _selfCareService: SelfCareService,
    @Inject(APP_BASE_HREF) public baseHref:string
  ) {
    super (_store, _fb, _dialog, _technicalService, _trackingService, _selfCareService);
    this.currentStep   = 0;
    this.buttonCallApi = new ButtonCallApi (_dialog, _technicalService);
  }

  override ngOnInit (): void {
    this._trackingService.init ('NAT', '');
    this._trackingService.trackEtape1 ();

    const _self = this;
    this.route.data.subscribe ({
                                 next: (v: unknown) => {
                                   _self._store.dispatch (initProfessions ({ professions: v['datas'].professionSelfcare }));
                                 },
                               });
  }

  onCheckButton (button: any, user: User) {
    this._trackingService.trackButtonClick (Etape3_trackingEnum.RECEVOIR_PAR_EMAIL);
    const civilite = Helper.getLittleCivilite (user.civilite);
    this._selfCareService.dialogEmail (user, `${civilite} ${capitalize (user.nom)} - Votre_bilan_prevoyance_personnalise_Groupama.pdf`);
  }

  override nexStepOne (user: User, queryParams: QueryParams, stepper?: MatStepper): boolean {
    const result = super.nexStepOne (user, queryParams);
    if (result) {
      stepper.next ();
    }
    this._cdr.markForCheck ();
    return null;
  }

  onStepOne () {
    this._store.dispatch (updateState ({ stateUpdated: EnumOuiNon.NON }));
  }

  eventTag ($event: StepperSelectionEvent) {
    console.log ($event.selectedIndex);
    switch ($event.selectedIndex) {
      case 0:
        this._trackingService.init ('NAT', '');
        this._trackingService.trackEtape1 ();
        break;
      case 1:
        this.step2initAndTrack ();
        break;
      case 2:
        this._trackingService.init ();
        this._trackingService.trackEtape3 ();
        break;
      case 3:
        this._trackingService.init ();
        this._trackingService.trackEtape4 ();
        break;
    }
  }


  // fixme a refactore ngrx
  private step2initAndTrack () {
    of ([]).pipe (
      untilDestroyed (this),
      withLatestFrom (
        this._store.select (selectUser),
        this._store.select (selectCaisses),
      ),
      map (([param, user, caisses]: [any, User, Caisse[]]) => {
        const caisse                       = CAISSE (user.codepostal, caisses);
        const trigrammeCaisse              = caisse.CR_TRACKING;
        const obj: GenericTagsObjInterface = GENERIC_TAGS_OBJ_INTERFACE (user, trigrammeCaisse);
        return {
          user, trigrammeCaisse, obj,
        };
      }),
    ).subscribe ({
                   next: v => {
                     this._trackingService.init (v.trigrammeCaisse, v.user.codepostal);
                     this._trackingService.trackEtape2 (v.obj);
                   },
                 });
  }
}
